import {
	START_FETCH_ARTICLES,
	FETCH_ARTICLES_SUCCESS,
	FETCH_ARTICLES_FAILED,
} from './action-types';

export function fetchArticlesAction() {
	return {
		type: START_FETCH_ARTICLES,
	};
}

export function fetchArticlesSuccessAction(articles) {
	return {
		type: FETCH_ARTICLES_SUCCESS,
		articles,
	};
}

export function fetchArticlesFailedAction(error, errorMessage) {
	return {
		type: FETCH_ARTICLES_FAILED,
		error,
		errorMessage,
	};
}
